export const ScreenProp = Object.freeze({
    Components: 'components',
    ShowSpinner: 'showSpinner',
    HasInputFields: 'hasInputFields',
});